<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      'token': null,
      'isRouterAlive': true,
      'apiIntervalNew': null,
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  created() {
    this.loginToken();
  },
  mounted() {
    // 页面刷新时调用
    window.onbeforeunload = e => {
      this.refresh();
    }

    var router = this.$route.path;
  },
  computed: {
    ...mapState([
      'assets',
      'taskWebSocket',
      'taskWbtTimer',
      'statWebsocket',
      'userName',
      'apiChartData',
      'apiInterval',
      'statisticSocket'
    ])
  },
  methods: {

    ...mapActions([
      'createAssetSocket',
      'createTaskSocket',
    ]),

    // 刷新调用
    refresh() {
      console.log('页面刷新');
      if (typeof this.taskWbtTimer.timer !== 'undefined') {// 如果timer 存在， 清除
        clearInterval(this.taskWbtTimer.timer);
      }

      if (typeof this.assets['assetSocket'] !== 'undefined') {
        this.assets['assetSocket'].force_close();
      }
      if (this.taskInfoSocket) {
        this.taskInfoSocket.testSocket.close();
      }
      if (this.statWebsocket) {
        this.statWebsocket.force_close();
      }
      if (this.statisticSocket) {
        this.statisticSocket.socket.close();
      }

    },

    // 页面刷新的 provide
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    },

    // 登录处理
    loginToken() {
      // 在login 页面则不用判断 
      // var this_url = this.$route.path;
      var this_url = window.location.href;
      if (this_url.indexOf('/login') !== -1) return;

      var ctoken = this.$cookies.get('token');
      var userName = this.$cookies.get('userName');
      if (ctoken) {// 如果cookies里有 token，
        this.token = ctoken;
        this.$store.commit('getToken', ctoken);
        this.$store.commit('getUserName', userName);
      } else {
        this.$router.push('/');
      }
    },

  }
}
</script>

<style>
#app {
  text-align: center;
  color: #2c3e50;
  height: 100%;
  font-size: 13px;
  background-color: #252425;
  font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
*{
  padding: 0;
  margin: 0;
}

/* 一级标题栏 */
.column-header { 
  height: 40px !important;
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size: 16px;
  color: #999;
};

/* 内容 el-main */
.btc-column-main {
  margin: 0 10px;
}

table{
  border-collapse: collapse;
}
html{
  height: 100%;
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
}
body{
  height: 100%;
  background-color: #252425;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.float-left{
  float: left;
}

.float-right{
  float: right;
}

.footer{
    /* position: fixed; */
    bottom: 0;
}

/* 清除浮动 */
.clearfloat:after{
  content: '';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfloat{
  zoom: 1;
}

ul li{
  list-style-type: none;
}

.el-header, .el-footer{
  padding: 0;
}

a{
  text-decoration: none;
}

.btn__style {
    border-radius: 3px;
    color: #616063;
    padding: 5px 10px;
    box-sizing: border-box;
    display: inline-block;
    font-size: 14px;
    background-color: #333333;
    border-color: #333333;
}
.btn__style:hover {
  color: #fff;
  background-color: #333333;
  border-color: #333333;
  cursor: pointer;
}
.btn__style:focus{
  background-color: #333333;
  border-color: #333333;
  color: #a8a7a9;

}
.btn__style_white {
    border-radius: 3px;
    color: #a8a7a9;
    padding: 8px 20px;
    box-sizing: border-box;
    display: inline-block;
    font-size: 12px;
    background-color: #fff;
    border-color: #eaeaea;
}

::-webkit-input-placeholder { /* WebKit browsers */
  font-size: 12px;
}

::-moz-placeholder { /* Mozilla Firefox 19+ */
  font-size: 12px;
}

:-ms-input-placeholder { /* Internet Explorer 10+ */
  font-size: 12px;
}  

/* loading 585858 */
.el-loading-spinner .path {
  stroke: #585858;
}



@media screen and (max-width: 420px) {
  .el-header{
    height: 50px !important;
  }
}
</style>
